import React from 'react'
import styled from 'styled-components'

const StyledPartnerItem = styled.li`
  display: flex;
  margin-bottom: 24px;
  width: 48%;

  &:nth-child(2n) {
    margin: 0 0 1.5rem 0;
  }

  @media screen and (min-width: 1025px) {
    padding: 24px 30px;
  }

  @media screen and (max-width: 780px) {
    width: 100%;
  }
`

const StyledPartnerItemTitle = styled.h4`
  font-size: 20px;
  margin: 0 0 6px 0;
`
const StyledPartnerItemText = styled.div`
  font-size: 16px;
  color: #262626;
`
const StyledPartnerItemImage = styled.div`
  align-items: flex-start;
  display: flex;
  margin-right: 0.75rem;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    width: 190px;
  }
`

const PartnerItem = props => {
  const content = (
    <StyledPartnerItem>
      <StyledPartnerItemImage className="styled-partner-item-img">
        <img src={props.img} alt={`icône ${props.title}`} />
      </StyledPartnerItemImage>
      <div>
        <StyledPartnerItemTitle isLogicImmo={props.isLogicImmo} className="styled-partner-item-title">
          {props.title}
        </StyledPartnerItemTitle>
        <StyledPartnerItemText className="styled-partner-item-text">{props.text}</StyledPartnerItemText>
      </div>
    </StyledPartnerItem>
  )
  return content
}

export default React.memo(PartnerItem)
